export enum USER_OPTIONS {
  ADD_FUNDS_TO_YOUR_WALLET = 'ADD_FUNDS_TO_YOUR_WALLET',
  ACCOUNT_INFORMATION = 'ACCOUNT_INFORMATION',
  CLIENT_SECRETS_REGENERATION = 'CLIENT_SECRETS_REGENERATION',
  LOW_BALANCE_NOTIFICATION = 'LOW_BALANCE_NOTIFICATION',
  ABOUT = 'ABOUT',
  DOCS_AND_SUPPORT_MOBILE = 'DOCS_AND_SUPPORT_MOBILE'
}
